/*
 * Fabled Framing — Shopify Theme JS
 * Consolidated from shop.html, product.html, custom.html
 * Cart system uses Shopify AJAX Cart API
 */
(function(){
  'use strict';

  /* ═══════════════════════════════════════════
     HELPERS
     ═══════════════════════════════════════════ */

  function fl(r){
    var ratio=(r.value-r.min)/(r.max-r.min);
    r.style.setProperty('--fl',ratio*100+'%');
    var track=r.closest('.slider-track');
    if(!track)return;
    track.style.setProperty('--fl-raw',ratio);
    /* The hint bubble is positioned along the track via --fl-raw and can run
       past the row's edge for sliders with many steps (e.g. near the max end
       of a long variant list) — even after it's "hidden" (opacity:0 only,
       still laid out), that overflow forces mobile browsers to widen their
       whole layout viewport. `transform` alone can't fix this: it's purely
       visual and doesn't change the element's layout box, which is what
       triggers the browser's viewport-widening check — so the correction has
       to land on `left` itself, measured with the transform stripped out
       first, then the usual -10px nudge (matching the caret offset in
       base.css) is reapplied on top for the visual. */
    var hint=track.querySelector('.slider-hint');
    var wrap=r.closest('.slider-wrap');
    if(hint&&wrap){
      var caret=hint.querySelector('.slider-hint-caret');
      hint.style.left='';
      hint.style.transform='none';
      if(caret)caret.style.left='';
      /* Thumb centre in viewport px — matches the native slider's own
         geometry (10px inset either side for the 20px thumb), independent
         of the bubble's position. Used to re-aim the caret if clamping
         below shifts the bubble away from where --fl-raw pointed it. */
      var rRect=r.getBoundingClientRect();
      var targetX=rRect.left+10+(rRect.width-20)*ratio;
      var hintRect=hint.getBoundingClientRect();
      var wrapRect=wrap.getBoundingClientRect();
      var extra=0;
      if(hintRect.right>wrapRect.right)extra=wrapRect.right-hintRect.right;
      else if(hintRect.left<wrapRect.left)extra=wrapRect.left-hintRect.left;
      if(extra){
        hint.style.left=(parseFloat(getComputedStyle(hint).left)+extra)+'px';
        hint.style.transform='translateX(-10px)';
        if(caret){
          var shiftedRect=hint.getBoundingClientRect();
          caret.style.left=(targetX-shiftedRect.left-5)+'px';
        }
      }else{
        hint.style.transform='translateX(-10px)';
      }
    }
  }

  function formatPrice(cents){
    var currency=window.FabledCart && window.FabledCart.cartCurrency;
    if(currency && typeof Intl!=='undefined' && Intl.NumberFormat){
      try{
        return new Intl.NumberFormat(undefined,{style:'currency',currency:currency}).format(cents/100);
      }catch(e){}
    }
    if(typeof Shopify!=='undefined'&&Shopify.formatMoney){
      return Shopify.formatMoney(cents, window.FabledCart && window.FabledCart.moneyFormat);
    }
    var pounds=cents/100;
    return '\u00a3'+pounds.toFixed(pounds%1?2:0);
  }

  /* First number anywhere in a variant title — handles both "8 Cards" and
     titles that lead with words, e.g. tarot's "Full Deck - 78 Cards". */
  function extractCount(str){var m=String(str).match(/\d+/);return m?parseInt(m[0],10):0}

  function trapFocus(container){
    var focusable=container.querySelectorAll('button,a[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
    var first=focusable[0],last=focusable[focusable.length-1];
    function handler(e){
      if(e.key!=='Tab')return;
      if(e.shiftKey){if(document.activeElement===first){e.preventDefault();last.focus()}}
      else{if(document.activeElement===last){e.preventDefault();first.focus()}}
    }
    container.addEventListener('keydown',handler);
    return function(){container.removeEventListener('keydown',handler)};
  }


  /* ═══════════════════════════════════════════
     MOBILE NAV TOGGLE
     ═══════════════════════════════════════════ */

  var navToggle=document.getElementById('nav-toggle');
  var drawer=document.getElementById('drawer');
  var drawerOv=document.getElementById('drawer-ov');
  var drawerX=document.getElementById('drawer-x');

  function openDrawer(){
    if(!drawer)return;
    drawer.classList.add('open');
    drawerOv.classList.add('open');
    navToggle.classList.add('open');
    navToggle.setAttribute('aria-expanded','true');
  }
  function closeDrawer(){
    if(!drawer)return;
    drawer.classList.remove('open');
    drawerOv.classList.remove('open');
    navToggle.classList.remove('open');
    navToggle.setAttribute('aria-expanded','false');
  }

  if(navToggle&&drawer){
    navToggle.addEventListener('click',function(){
      if(drawer.classList.contains('open')){closeDrawer();}else{openDrawer();}
    });
    if(drawerX)drawerX.addEventListener('click',closeDrawer);
    if(drawerOv)drawerOv.addEventListener('click',closeDrawer);
    drawer.querySelectorAll('.drawer-body a, .drawer-cta').forEach(function(link){
      link.addEventListener('click',closeDrawer);
    });
  }


  /* ═══════════════════════════════════════════
     TOAST
     ═══════════════════════════════════════════ */

  var toastEl=document.getElementById('toast'),toastTimer;
  function showToast(msg){
    if(!toastEl)return;
    toastEl.textContent=msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer=setTimeout(function(){toastEl.classList.remove('show')},3000);
  }


  /* ═══════════════════════════════════════════
     SHOPIFY CART API
     ═══════════════════════════════════════════ */

  var cartConfig=window.FabledCart||{};

  function fetchCart(){
    return fetch('/cart.js',{
      method:'GET',
      headers:{'Content-Type':'application/json'}
    }).then(function(r){return r.json()});
  }

  function addToCart(variantId, quantity, properties, skipDrawer){
    quantity=quantity||1;
    var item={id:variantId,quantity:quantity};
    if(properties&&Object.keys(properties).length)item.properties=properties;
    return fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[item]})
    })
    .then(function(r){return r.json()})
    .then(function(data){
      updateBadgeFromApi(true,skipDrawer);
      return data;
    });
  }

  function removeFromCart(lineKey){
    return fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:lineKey,quantity:0})
    })
    .then(function(r){return r.json()})
    .then(function(cart){
      updateBadgeFromApi();
      renderCartFromData(cart);
      return cart;
    });
  }

  function changeQuantity(lineKey, newQty){
    if(newQty<1)return removeFromCart(lineKey);
    return fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:lineKey,quantity:newQty})
    })
    .then(function(r){return r.json()})
    .then(function(cart){
      updateBadgeFromApi();
      renderCartFromData(cart);
      return cart;
    });
  }

  function updateBadgeFromApi(animate,skipDrawer){
    fetchCart().then(function(cart){
      var count=cart.item_count;
      document.querySelectorAll('.badge').forEach(function(b){
        b.textContent=count;
        if(count>0){b.classList.add('badge-has-items')}
        else{b.classList.remove('badge-has-items')}
        if(animate){
          b.classList.remove('badge-pop','badge-flash');
          void b.offsetWidth;
          b.classList.add('badge-pop','badge-flash');
        }
      });
      document.querySelectorAll('.nav-cart').forEach(function(a){
        a.setAttribute('aria-label','Cart, '+count+' items');
      });
      if(animate&&!skipDrawer){openCart()}
    });
  }

  function escapeHtml(str){
    return String(str).replace(/[&<>"']/g,function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function formatItemProperties(props){
    if(!props)return '';
    var parts=[];
    Object.keys(props).forEach(function(key){
      if(key.charAt(0)==='_')return;
      var val=props[key];
      if(val===null||val===undefined||val==='')return;
      parts.push('<span class="cart-item-prop"><b>'+escapeHtml(key)+':</b> '+escapeHtml(val)+'</span>');
    });
    return parts.join('');
  }

  function renderCartFromData(cart){
    var items=document.getElementById('cart-items');
    var footer=document.getElementById('cart-footer');
    if(!items||!footer)return;

    if(!cart.items||!cart.items.length){
      items.innerHTML='<p class="cart-empty">Your cart is empty</p>';
      footer.innerHTML='';
      return;
    }
    var html='';
    cart.items.forEach(function(item){
      html+='<div class="cart-item" data-key="'+item.key+'">';
      html+='<div class="cart-item-info">';
      html+='<div class="cart-item-title">'+item.product_title+'</div>';
      html+='<div class="cart-item-variant">'+item.variant_title+'</div>';
      var propsHtml=formatItemProperties(item.properties);
      if(propsHtml)html+='<div class="cart-item-props">'+propsHtml+'</div>';
      html+='</div>';
      html+='<div class="cart-item-qty">';
      html+='<button class="cart-qty-btn cart-qty-minus" data-key="'+item.key+'" data-qty="'+item.quantity+'" aria-label="Decrease quantity">&minus;</button>';
      html+='<span class="cart-qty-num">'+item.quantity+'</span>';
      html+='<button class="cart-qty-btn cart-qty-plus" data-key="'+item.key+'" data-qty="'+item.quantity+'" aria-label="Increase quantity">&plus;</button>';
      html+='</div>';
      html+='<span class="cart-item-price">'+formatPrice(item.final_line_price)+'</span>';
      html+='<button class="cart-item-rm" data-key="'+item.key+'" aria-label="Remove item">&#x2715;</button>';
      html+='</div>';
    });
    items.innerHTML=html;

    footer.innerHTML='<div class="cart-total"><span class="cart-total-label">Subtotal</span><span class="cart-total-price">'+formatPrice(cart.total_price)+'</span></div><a href="/checkout" class="btn cart-checkout">Continue to Checkout</a>';

    items.querySelectorAll('.cart-item-rm').forEach(function(btn){
      btn.addEventListener('click',function(){
        removeFromCart(btn.dataset.key);
      });
    });
    items.querySelectorAll('.cart-qty-minus').forEach(function(btn){
      btn.addEventListener('click',function(){
        changeQuantity(btn.dataset.key,parseInt(btn.dataset.qty)-1);
      });
    });
    items.querySelectorAll('.cart-qty-plus').forEach(function(btn){
      btn.addEventListener('click',function(){
        changeQuantity(btn.dataset.key,parseInt(btn.dataset.qty)+1);
      });
    });
  }


  /* ═══════════════════════════════════════════
     CART DRAWER
     ═══════════════════════════════════════════ */

  var cartDrawer=document.getElementById('cart-drawer');
  var cartOv=document.getElementById('cart-ov');
  var cartX=document.getElementById('cart-x');
  var cartTrap=null,cartLast=null;

  function openCart(){
    cartLast=document.activeElement;
    fetchCart().then(function(cart){
      renderCartFromData(cart);
      cartOv.classList.add('on');
      cartDrawer.classList.add('on');
      if(cartX)cartX.focus();
      cartTrap=trapFocus(cartDrawer);
    });
  }

  function closeCart(){
    if(cartOv)cartOv.classList.remove('on');
    if(cartDrawer)cartDrawer.classList.remove('on');
    if(cartTrap){cartTrap();cartTrap=null}
    if(cartLast)cartLast.focus();
  }

  if(cartX)cartX.addEventListener('click',closeCart);
  if(cartOv)cartOv.addEventListener('click',closeCart);

  document.querySelectorAll('.nav-cart').forEach(function(a){
    a.addEventListener('click',function(e){
      e.preventDefault();
      openCart();
    });
  });


  /* ═══════════════════════════════════════════
     SHOWCASE CAROUSEL (homepage only)
     ═══════════════════════════════════════════ */

  var scViewer=document.getElementById('sc-viewer');
  if(scViewer){
    var scDots=document.getElementById('sc-dots'),scInfo=document.getElementById('sc-info'),
        scCap=document.getElementById('sc-cap'),scDet=document.getElementById('sc-det'),
        scPrev=document.getElementById('sc-prev'),scNext=document.getElementById('sc-next'),
        allSlides=document.querySelectorAll('.sc-sl'),loaded=[],si=0,st,sp=false,ck=0;

    allSlides.forEach(function(s){
      var img=s.querySelector('img'),settled=false;
      /* An image that finished loading while the page was parsing reports
         complete=true here AND still fires its queued load event, so guard
         against counting it twice (that skewed `loaded` against the dots
         and left the viewer blank, throwing on every autoplay tick). */
      function ok(){if(settled)return;settled=true;loaded.push(s);ck++;if(ck===allSlides.length)initShowcase()}
      function er(){if(settled)return;settled=true;s.style.display='none';ck++;if(ck===allSlides.length)initShowcase()}
      if(img){
        img.addEventListener('load',ok);
        img.addEventListener('error',er);
        if(img.complete){img.naturalWidth>0?ok():er()}
      }else{er()}
    });

    function initShowcase(){
      if(!loaded.length)return;
      /* load events arrive in network order — keep slides in page order and
         make sure the one marked active is the first of them */
      loaded.sort(function(a,b){return a.compareDocumentPosition(b)&Node.DOCUMENT_POSITION_FOLLOWING?-1:1});
      allSlides.forEach(function(s){s.classList.toggle('active',s===loaded[0])});
      loaded.forEach(function(s,idx){
        var d=document.createElement('button');
        d.className='dot'+(idx===0?' active':'');
        d.setAttribute('aria-label','Slide '+(idx+1));
        d.setAttribute('role','tab');
        d.setAttribute('aria-selected',idx===0?'true':'false');
        d.addEventListener('click',function(){goSlide(idx)});
        scDots.appendChild(d);
      });
      showCaption();
      st=setInterval(function(){if(!sp)goSlide((si+1)%loaded.length)},5000);
    }

    function goSlide(idx){
      loaded[si].classList.remove('active');
      scDots.children[si].classList.remove('active');
      scDots.children[si].setAttribute('aria-selected','false');
      si=idx;
      loaded[si].classList.add('active');
      scDots.children[si].classList.add('active');
      scDots.children[si].setAttribute('aria-selected','true');
      showCaption();
    }

    function showCaption(){
      if(!scInfo)return;
      scInfo.classList.add('fading');
      setTimeout(function(){
        if(scCap)scCap.textContent=loaded[si].dataset.caption||'';
        if(scDet)scDet.textContent=loaded[si].dataset.detail||'';
        scInfo.classList.remove('fading');
      },300);
    }

    /* Pause when tab hidden */
    document.addEventListener('visibilitychange',function(){
      if(document.hidden){clearInterval(st)}
      else if(!sp&&loaded.length){st=setInterval(function(){goSlide((si+1)%loaded.length)},5000)}
    });

    /* Keyboard navigation */
    scViewer.setAttribute('tabindex','0');
    scViewer.setAttribute('role','region');
    scViewer.setAttribute('aria-label','Customer showcase carousel');
    scViewer.addEventListener('keydown',function(e){
      if(e.key==='ArrowLeft'){e.preventDefault();goSlide((si-1+loaded.length)%loaded.length)}
      else if(e.key==='ArrowRight'){e.preventDefault();goSlide((si+1)%loaded.length)}
    });
    scViewer.addEventListener('focusin',function(){clearInterval(st)});
    scViewer.addEventListener('focusout',function(){
      if(!sp&&loaded.length){st=setInterval(function(){goSlide((si+1)%loaded.length)},5000)}
    });

    /* Swipe gestures */
    var touchStartX=0;
    scViewer.addEventListener('touchstart',function(e){touchStartX=e.changedTouches[0].clientX},{passive:true});
    scViewer.addEventListener('touchend',function(e){
      var dx=e.changedTouches[0].clientX-touchStartX;
      if(Math.abs(dx)>50){
        sp=true;clearInterval(st);
        if(dx<0)goSlide((si+1)%loaded.length);
        else goSlide((si-1+loaded.length)%loaded.length);
      }
    },{passive:true});

    /* Prev / Next arrow buttons */
    if(scPrev){scPrev.addEventListener('click',function(){
      if(!loaded.length)return;
      sp=true;clearInterval(st);
      goSlide((si-1+loaded.length)%loaded.length);
    })}
    if(scNext){scNext.addEventListener('click',function(){
      if(!loaded.length)return;
      sp=true;clearInterval(st);
      goSlide((si+1)%loaded.length);
    })}
  }


  /* ═══════════════════════════════════════════
     FAQ ACCORDION (homepage only)
     ═══════════════════════════════════════════ */

  document.querySelectorAll('.faq-q').forEach(function(b){
    b.addEventListener('click',function(){
      var it=b.parentElement;
      var wasOpen=it.classList.contains('open');
      document.querySelectorAll('.faq-i.open').forEach(function(x){
        x.classList.remove('open');
        x.querySelector('.faq-q').setAttribute('aria-expanded','false');
      });
      if(!wasOpen){
        it.classList.add('open');
        b.setAttribute('aria-expanded','true');
      }
    });
  });


  /* ═══════════════════════════════════════════
     SCROLL REVEAL (homepage only)
     ═══════════════════════════════════════════ */

  var revealEls=document.querySelectorAll('.reveal');
  if(revealEls.length){
    if('IntersectionObserver' in window){
      var revObs=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('visible');
            revObs.unobserve(entry.target);
          }
        });
      },{threshold:0.15});
      revealEls.forEach(function(el){revObs.observe(el)});
      /* Stagger collection cards */
      document.querySelectorAll('.grid .card').forEach(function(card,i){
        card.classList.add('reveal','reveal-d'+Math.min(i,7));
        revObs.observe(card);
      });
    }else{
      revealEls.forEach(function(el){el.classList.add('visible')});
    }
  }


  /* ═══════════════════════════════════════════
     PRODUCT PAGE — Slab Type & Grid Layout options
     ═══════════════════════════════════════════ */

  var slabState=(function(){
    var typeTiles=document.getElementById('slab-type-tiles');
    var gridHolder=document.getElementById('slab-grid-options');
    var fixedType=document.getElementById('slab-fixed-type');
    /* Per-grader product pages: the grader is fixed and the layout is the one layout for the count */
    if(fixedType){
      return {properties:function(){
        var props={'Slab Type':fixedType.getAttribute('data-type')};
        var api=window.FFSlabFrame,el=document.getElementById('prod-v');
        var n=el?parseInt(el.textContent,10):0;
        var l=(api&&n&&api.getLayouts)?api.getLayouts(n)[0]:null;
        if(l)props['Layout']=l.cols+'×'+l.rows;
        return props;
      }};
    }
    if(!typeTiles&&!gridHolder)return null;

    var state={type:null,gridPick:null};

    /* ── Slab type tiles ── */
    if(typeTiles){
      var otherModal=document.getElementById('slab-other-modal');
      function showOtherModal(){
        if(!otherModal)return;
        otherModal.hidden=false;
        var first=otherModal.querySelector('[data-slab-modal-go]');
        if(first)setTimeout(function(){first.focus()},50);
      }
      function hideOtherModal(){if(otherModal)otherModal.hidden=true}

      typeTiles.querySelectorAll('.cf-tile').forEach(function(tile){
        tile.addEventListener('click',function(){
          /* "Other" isn't a purchasable option — confirm before sending them
             off to the custom order form instead of selecting it. */
          if(tile.hasAttribute('data-confirm-nav')){
            showOtherModal();
            return;
          }
          typeTiles.querySelectorAll('.cf-tile').forEach(function(t){
            if(t.hasAttribute('data-confirm-nav'))return;
            t.classList.remove('is-selected');t.setAttribute('aria-checked','false');
          });
          tile.classList.add('is-selected');
          tile.setAttribute('aria-checked','true');
          state.type=tile.dataset.value;
        });
      });

      if(otherModal){
        var otherTile=typeTiles.querySelector('[data-confirm-nav]');
        var goBtn=otherModal.querySelector('[data-slab-modal-go]');
        if(goBtn)goBtn.addEventListener('click',function(){
          window.location.href=otherTile?otherTile.dataset.confirmNav:'/pages/custom-order';
        });
        otherModal.querySelectorAll('[data-slab-modal-stay],[data-slab-modal-dismiss]').forEach(function(el){
          el.addEventListener('click',hideOtherModal);
        });
        document.addEventListener('keydown',function(e){
          if(e.key==='Escape'&&!otherModal.hidden)hideOtherModal();
        });
      }
    }

    /* ── Grid layout ── */
    /* Options come from frame-dimensions.liquid's own per-count layout table
       (window.FFSlabFrame) rather than generic factorization, so every option
       shown here is a layout we can actually verify real frame dimensions for:
       the canonical layout for this count, its 90°-rotated counterpart, and
       any hand-specified extra layouts for that count. */
    if(gridHolder){
      var gridWrap=document.getElementById('slab-grid-layout-wrap');

      function currentCount(){
        var el=document.getElementById('prod-v');
        var n=el?parseInt(el.textContent,10):0;
        return isNaN(n)?0:n;
      }

      function renderGrids(){
        var api=window.FFSlabFrame;
        var n=currentCount();
        var layouts=(api&&n&&api.getLayouts)?api.getLayouts(n):[];
        if(!layouts.length){
          gridHolder.innerHTML='';
          if(gridWrap)gridWrap.hidden=true;
          state.gridPick=null;
          return;
        }
        if(gridWrap)gridWrap.hidden=false;

        /* Cap at 2 so the row's height (and the space it needs) stays
           consistent across every slab count, however many layouts a
           count's SLAB_EXTRA_LAYOUTS entry ends up listing. Extras are
           ordered before the auto-rotation (see getSlabLayouts) so a
           deliberately-chosen extra always wins the second slot. */
        var opts=layouts.slice(0,2).map(function(l){return {c:l.cols,r:l.rows}});

        state.gridPick=opts[0];
        gridHolder.innerHTML='';
        opts.forEach(function(o,i){
          var b=document.createElement('button');
          b.type='button';
          b.className='cf-grid-opt';
          b.setAttribute('role','radio');
          b.innerHTML=o.c+' across<br>'+o.r+' down';
          var selected=(i===0);
          b.classList.toggle('is-selected',selected);
          b.setAttribute('aria-checked',selected?'true':'false');
          b.addEventListener('click',function(){
            state.gridPick={c:o.c,r:o.r};
            gridHolder.querySelectorAll('.cf-grid-opt').forEach(function(x){x.classList.remove('is-selected');x.setAttribute('aria-checked','false')});
            b.classList.add('is-selected');
            b.setAttribute('aria-checked','true');
            if(api)api.setOrientation(o.c,o.r);
          });
          gridHolder.appendChild(b);
        });
      }

      /* Deferred: the variant-slider setup below (later in this file) sets the
         initial slab count — e.g. defaulting the page to "8" — so wait for that
         to land before computing the layout, both on load and on every slide. */
      setTimeout(renderGrids,0);

      var prodCardsEl=document.getElementById('prod-cards');
      if(prodCardsEl){
        prodCardsEl.addEventListener('input',function(){
          setTimeout(renderGrids,0);
        });
      }
    }

    function properties(){
      var props={};
      if(state.type)props['Slab Type']=state.type;
      if(state.gridPick)props['Layout']=state.gridPick.c+'×'+state.gridPick.r;
      return props;
    }

    return {properties:properties};
  })();

  function getSlabProperties(){
    return slabState?slabState.properties():{};
  }


  /* ═══════════════════════════════════════════
     PRODUCT PAGE — Variant Slider & Image Swap
     ═══════════════════════════════════════════ */

  var prodSlider=document.getElementById('prod-cards');
  if(prodSlider){
    var prodJsonEl=document.getElementById('product-json');
    var product=null,variants=null;

    try{product=JSON.parse(prodJsonEl.textContent)}catch(e){}

    if(product){
      /* Slider runs low → high regardless of the order variants were created in */
      /* Option layout: the card-count option drives the slider; an "Acrylic" option (if the product has one) is a separate selector */
      var pOptNames=(product.options||[]).map(function(o){return (o&&o.name)?o.name:String(o)});
      var acrylicIdx=-1,countIdx=0;
      pOptNames.forEach(function(n,i){if(acrylicIdx<0&&/acrylic|glaz|glass/i.test(n))acrylicIdx=i});
      for(var oi=0;oi<pOptNames.length;oi++){if(oi!==acrylicIdx&&!/size/i.test(pOptNames[oi])){countIdx=oi;break}}
      function vCount(v){var o=v['option'+(countIdx+1)];var c=extractCount(o==null?v.title:o);return c||extractCount(v.title)}
      function vAcrylic(v){return acrylicIdx>-1?v['option'+(acrylicIdx+1)]:null}
      var acrylicValues=[];
      if(acrylicIdx>-1){product.variants.forEach(function(v){var a=vAcrylic(v);if(a&&acrylicValues.indexOf(a)<0)acrylicValues.push(a)})}
      var activeAcrylic=acrylicValues.length>1?acrylicValues[0]:null;
      var allVariants=product.variants.filter(function(v){return !activeAcrylic||vAcrylic(v)===activeAcrylic}).sort(function(a,b){return vCount(a)-vCount(b)});
      variants=allVariants;
      /* Count the slider starts on (liquid sets it per product; 8 is the norm) */
      var defaultCount=parseInt(prodSlider.getAttribute('data-default-count'),10)||8;
      var sliderBounds=document.querySelectorAll('.slider-wrap .slider-bound');
      function setSliderBounds(){
        if(sliderBounds.length<2||!variants.length)return;
        sliderBounds[0].textContent=vCount(variants[0]);
        sliderBounds[1].textContent=vCount(variants[variants.length-1]);
      }
      var heroImg=document.getElementById('product-hero');
      var imgWrap=document.querySelector('.product-img-wrap');
      var staticImg=imgWrap&&imgWrap.hasAttribute('data-static-img');
      var assetBase=(!staticImg&&imgWrap)?imgWrap.getAttribute('data-asset-base'):'';
      /* Counts not listed fall back to the shared <count>.webp */
      var typeKey=imgWrap?imgWrap.getAttribute('data-image-key'):'';
      /* Per-type count photos: assets/<prefix>-<count>.webp. Types sharing a set map to the same prefix. */
      var typePrefix={pokemon:'p',onepiece:'p',sports:'p',yugioh:'y',riftbound:'r',mtg:'m',lorcana:'l',other:'l'};
      var typedCounts=[1,2,3,4,5,6,7,8,9,10,12,15,18,20,25,30,36,40,45,50,55,60,64,65,70,80,90,100,16];
      var photoPrefix=typePrefix[typeKey]||'';
      /* Per-grader slab products name their own suffix (10-psa.webp) and have a photo for every count */
      var graderPrefix=imgWrap?imgWrap.getAttribute('data-photo-prefix'):'';
      function countImg(n){
        if(graderPrefix)return assetBase+n+'-'+graderPrefix+'.webp';
        return assetBase+((photoPrefix&&typedCounts.indexOf(n)>-1)?photoPrefix+'-':'')+n+'.webp';
      }
      var svEl=document.getElementById('prod-v');
      var priceEl=document.getElementById('prod-p');
      var hiddenId=document.getElementById('prod-variant-id');
      var prodBtn=document.getElementById('prod-btn');

      /* ── Size toggle (Playing Cards: Bridge / Poker) ── */
      var sizeToggle=document.getElementById('size-toggle');
      var hasSize=sizeToggle!=null;
      var activeSize='';

      function filterBySize(size){
        activeSize=size;
        if(!size){
          variants=allVariants;
        }else{
          var filtered=allVariants.filter(function(v){return v.option2===size});
          /* If no variants match option2 (product not yet configured with 2 options),
             fall back to showing all variants so the page still works */
          variants=filtered.length?filtered:allVariants;
        }
      }

      function resetSlider(){
        prodSlider.min=0;
        prodSlider.max=Math.max(variants.length-1,0);
        prodSlider.step=1;
        setSliderBounds();
        var initIdx=0,initDist=Infinity;
        for(var vi=0;vi<variants.length;vi++){
          var d=Math.abs(vCount(variants[vi])-defaultCount);
          if(d<initDist){initDist=d;initIdx=vi}
        }
        prodSlider.value=initIdx;
        lastIdx=-1;
        applyVariantByIndex(initIdx);
      }

      if(hasSize){
        /* Initialise with first button's size */
        var firstSizeBtn=sizeToggle.querySelector('.size-btn.active');
        if(firstSizeBtn)filterBySize(firstSizeBtn.dataset.size);

        sizeToggle.addEventListener('click',function(e){
          var btn=e.target.closest('.size-btn');
          if(!btn||btn.classList.contains('active'))return;
          sizeToggle.querySelector('.size-btn.active').classList.remove('active');
          btn.classList.add('active');
          filterBySize(btn.dataset.size);
          resetSlider();
        });
      }

      /* Setup slider — start at the variant closest to the product's default count */
      prodSlider.min=0;
      prodSlider.max=variants.length-1;
      prodSlider.step=1;
      setSliderBounds();
      var initIdx=0,initDist=Infinity;
      for(var vi=0;vi<variants.length;vi++){
        var d=Math.abs(vCount(variants[vi])-defaultCount);
        if(d<initDist){initDist=d;initIdx=vi}
      }
      prodSlider.value=initIdx;

      /* Image swap with debounce */
      var currentSrc=heroImg?heroImg.src:'';
      var debounceTimer=null,fadeTimer=null;
      var fadeOutDuration=250;

      function swapImage(newSrc){
        if(!heroImg||newSrc===currentSrc||heroImg.src.indexOf(newSrc)!==-1)return;
        currentSrc=newSrc;
        clearTimeout(debounceTimer);
        clearTimeout(fadeTimer);
        heroImg.classList.remove('is-fading');
        heroImg.onload=null;

        debounceTimer=setTimeout(function(){
          heroImg.classList.add('is-fading');
          fadeTimer=setTimeout(function(){
            heroImg.onload=function(){
              heroImg.classList.remove('is-fading');
              heroImg.onload=null;
            };
            heroImg.src=currentSrc;
            if(heroImg.complete){
              heroImg.classList.remove('is-fading');
              heroImg.onload=null;
            }
          },fadeOutDuration);
        },500);
      }

      /* Preload variant images */
      if(assetBase){
        allVariants.forEach(function(v){
          var img=new Image();
          img.src=countImg(vCount(v));
        });
      }

      var lastIdx=-1;

      function applyVariantByIndex(idx){
        var variant=variants[idx];
        if(!variant)return;

        var count=vCount(variant);
        if(svEl)svEl.textContent=count;
        if(priceEl)priceEl.textContent=formatPrice(variant.price);
        if(hiddenId)hiddenId.value=variant.id;

        if(prodBtn){
          if(variant.available){
            prodBtn.disabled=false;
            prodBtn.textContent='Add to Cart';
          }else{
            prodBtn.disabled=true;
            prodBtn.textContent='Sold Out';
          }
        }

        /* If the video is playing, moving the slider should stop it and switch back to the image */
        var vidEl=document.getElementById('product-video');
        if(vidEl&&vidEl.style.display==='block'){
          vidEl.pause();
          vidEl.style.display='none';
          if(heroImg)heroImg.style.display='';
        }

        /* Swap image using asset filename */
        if(assetBase){
          swapImage(countImg(count));
          document.querySelectorAll('.prod-thumb').forEach(function(t){t.classList.remove('is-active');t.setAttribute('aria-selected','false');});
        }

        fl(prodSlider);
        lastIdx=idx;
      }

      var sliderHint=document.getElementById('slider-hint');
      prodSlider.addEventListener('input',function(){
        if(sliderHint&&!sliderHint.classList.contains('hidden'))sliderHint.classList.add('hidden');
        var idx=+prodSlider.value;
        if(idx!==lastIdx)applyVariantByIndex(idx);
      });
      prodSlider.addEventListener('change',function(){
        applyVariantByIndex(+prodSlider.value);
      });

      /* ── Acrylic type selector: swaps the variant set, keeps the chosen card count ── */
      var acrylicWrap=document.getElementById('acrylic-select');
      var acrylicTiles=document.getElementById('acrylic-tiles');
      function updateAcrylicLabels(){
        if(!acrylicTiles)return;
        var cur=variants[+prodSlider.value];if(!cur)return;
        var n=vCount(cur),base=null;
        acrylicTiles.querySelectorAll('.cf-tile').forEach(function(t){
          var m=product.variants.filter(function(v){return vAcrylic(v)===t.dataset.value&&vCount(v)===n})[0];
          var d=t.querySelector('.cf-tile-price');
          if(!m||!d)return;
          if(base===null)base=m.price;
          var diff=m.price-base;
          d.textContent=diff===0?'Included':(diff>0?'+':'−')+formatPrice(Math.abs(diff));
        });
      }
      function setAcrylic(val){
        var n=vCount(variants[+prodSlider.value]||variants[0]);
        activeAcrylic=val;
        allVariants=product.variants.filter(function(v){return vAcrylic(v)===val}).sort(function(a,b){return vCount(a)-vCount(b)});
        if(hasSize)filterBySize(activeSize);else variants=allVariants;
        prodSlider.max=Math.max(variants.length-1,0);
        setSliderBounds();
        var idx=0,dist=Infinity;
        for(var i=0;i<variants.length;i++){var dd=Math.abs(vCount(variants[i])-n);if(dd<dist){dist=dd;idx=i}}
        prodSlider.value=idx;
        lastIdx=-1;
        prodSlider.dispatchEvent(new Event('input'));
        acrylicTiles.querySelectorAll('.cf-tile').forEach(function(t){
          var on=t.dataset.value===val;
          t.classList.toggle('is-selected',on);
          t.setAttribute('aria-checked',on?'true':'false');
        });
      }
      if(acrylicWrap&&acrylicTiles&&activeAcrylic){
        acrylicValues.forEach(function(val){
          var b=document.createElement('button');
          b.type='button';
          b.className='cf-tile cf-tile-sm';
          b.setAttribute('role','radio');
          b.dataset.value=val;
          b.innerHTML='<span class="cf-tile-name"></span><span class="cf-tile-price"></span>';
          b.firstChild.textContent=val;
          b.addEventListener('click',function(){if(val!==activeAcrylic)setAcrylic(val)});
          acrylicTiles.appendChild(b);
        });
        acrylicWrap.hidden=false;
        prodSlider.addEventListener('input',updateAcrylicLabels);
      }

      /* Init */
      applyVariantByIndex(initIdx);
      if(acrylicWrap&&activeAcrylic){
        acrylicTiles.querySelectorAll('.cf-tile').forEach(function(t){
          var on=t.dataset.value===activeAcrylic;
          t.classList.toggle('is-selected',on);
          t.setAttribute('aria-checked',on?'true':'false');
        });
        updateAcrylicLabels();
      }

      /* Product ATC interception */
      var prodForm=document.querySelector('.atc-form');
      if(prodForm){
        prodForm.addEventListener('submit',function(e){
          e.preventDefault();
          var v=variants[+prodSlider.value];
          if(!v||!v.available)return;
          addToCart(v.id,1,getSlabProperties());
        });
      }

      /* ── Sticky ATC bar ── */
      var stickyBar=document.getElementById('sticky-bar');
      var sbTitle=document.getElementById('sb-title'),sbCount=document.getElementById('sb-count'),
          sbPrice=document.getElementById('sb-price'),sbAtc=document.getElementById('sb-atc');
      var prodOptions=document.querySelector('.product-options');

      if(stickyBar&&prodOptions&&'IntersectionObserver' in window){
        function syncSticky(){
          var v=variants[+prodSlider.value];if(!v)return;
          if(sbTitle)sbTitle.textContent=product.title;
          if(sbCount)sbCount.textContent=vCount(v);
          if(sbPrice)sbPrice.textContent=formatPrice(v.price);
          if(sbAtc){
            sbAtc.disabled=!v.available;
            sbAtc.textContent=v.available?'Add to Cart':'Sold Out';
          }
        }
        syncSticky();
        prodSlider.addEventListener('input',syncSticky);

        var stickyObs=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            stickyBar.classList.toggle('show',!entry.isIntersecting);
          });
        },{threshold:0});
        stickyObs.observe(prodOptions);

        if(sbAtc){
          sbAtc.addEventListener('click',function(){
            var v=variants[+prodSlider.value];
            if(!v||!v.available)return;
            addToCart(v.id,1,getSlabProperties());
          });
        }
      }
    }
  }


  /* ═══════════════════════════════════════════
     PRODUCT PAGE — Complete Collection (fixed variant)
     ═══════════════════════════════════════════ */

  var pcPage=document.querySelector('.product-page.is-complete');
  if(pcPage){
    var pcHero=document.getElementById('product-hero');
    var pcThumbs=pcPage.querySelectorAll('.pc-thumb');
    var pcVideo=document.getElementById('product-video');
    pcThumbs.forEach(function(btn){
      btn.addEventListener('click',function(){
        var isVideo=btn.getAttribute('data-type')==='video';
        if(isVideo){
          if(pcHero)pcHero.style.display='none';
          if(pcVideo){pcVideo.style.display='block';pcVideo.load();var pp=pcVideo.play();if(pp)pp.catch(function(){});}
        }else{
          if(pcVideo){pcVideo.pause();pcVideo.style.display='none';}
          var full=btn.getAttribute('data-full');
          if(pcHero){
            pcHero.style.display='';
            if(full){
              pcHero.classList.add('is-fading');
              setTimeout(function(){
                pcHero.src=full;
                pcHero.classList.remove('is-fading');
              },180);
            }
          }
        }
        pcThumbs.forEach(function(t){t.classList.remove('is-active');t.setAttribute('aria-selected','false');});
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected','true');
      });
    });

    var pcProduct=null;
    try{pcProduct=JSON.parse((document.getElementById('product-json')||{}).textContent||'null')}catch(e){}
    var pcForm=pcPage.querySelector('.atc-form');
    var pcBtn=document.getElementById('prod-btn');
    var pcHidden=document.getElementById('prod-variant-id');
    if(pcForm&&pcHidden){
      pcForm.addEventListener('submit',function(e){
        e.preventDefault();
        var vid=parseInt(pcHidden.value,10);
        if(!vid)return;
        addToCart(vid,1,null);
      });
    }

    /* Sticky ATC for complete products */
    var pcStickyBar=document.getElementById('sticky-bar');
    var pcAnchor=pcPage.querySelector('.pc-atc');
    if(pcStickyBar&&pcAnchor&&'IntersectionObserver' in window){
      var sbAtc2=document.getElementById('sb-atc');
      if(sbAtc2&&pcHidden){
        sbAtc2.addEventListener('click',function(){
          var vid=parseInt(pcHidden.value,10);
          if(!vid)return;
          addToCart(vid,1,null);
        });
      }
      var pcObs=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          pcStickyBar.classList.toggle('show',!entry.isIntersecting);
        });
      },{threshold:0});
      pcObs.observe(pcAnchor);
    }
  }


  /* ═══════════════════════════════════════════
     PRODUCT GALLERY — regular products
     ═══════════════════════════════════════════ */

  var rpSection=document.querySelector('.product-page:not(.is-complete) .product-img');
  if(rpSection){
    var rpHero=document.getElementById('product-hero');
    var rpVideo=document.getElementById('product-video');
    var rpVideoDefault=rpVideo?rpVideo.getAttribute('src'):'';
    var rpThumbs=rpSection.querySelectorAll('.prod-thumb');
    /* Warm the cache for extra videos so they start instantly when tapped */
    var rpWarm=function(){
      rpSection.querySelectorAll('.prod-thumb[data-video]').forEach(function(t){
        var pv=document.createElement('video');
        pv.preload='auto';pv.muted=true;pv.setAttribute('playsinline','');
        pv.src=t.getAttribute('data-video');
      });
    };
    if(document.readyState==='complete')rpWarm();else window.addEventListener('load',rpWarm);
    rpThumbs.forEach(function(btn){
      btn.addEventListener('click',function(){
        var isVideo=btn.getAttribute('data-type')==='video';
        if(isVideo){
          if(rpHero)rpHero.style.display='none';
          if(rpVideo){
            var wantSrc=btn.getAttribute('data-video')||rpVideoDefault;
            if(rpVideo.getAttribute('src')!==wantSrc)rpVideo.setAttribute('src',wantSrc);
            rpVideo.classList.toggle('is-cover',!!btn.getAttribute('data-video'));
            rpVideo.style.display='block';rpVideo.load();var rp=rpVideo.play();if(rp)rp.catch(function(){});
          }
        }else{
          if(rpVideo){rpVideo.pause();rpVideo.style.display='none';}
          var full=btn.getAttribute('data-full');
          if(rpHero){
            rpHero.style.display='';
            if(full){
              rpHero.classList.add('is-fading');
              setTimeout(function(){
                rpHero.src=full;
                rpHero.classList.remove('is-fading');
              },180);
            }
          }
        }
        rpThumbs.forEach(function(t){t.classList.remove('is-active');t.setAttribute('aria-selected','false');});
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected','true');
      });
    });
  }

  /* Swipe through the gallery on mobile (both product types): left = next, right = previous */
  (function(){
    var wrap=document.querySelector('.product-img-wrap,.pc-img-wrap');
    if(!wrap)return;
    var tx=0;
    wrap.addEventListener('touchstart',function(e){tx=e.touches[0].clientX;},{passive:true});
    wrap.addEventListener('touchend',function(e){
      var dx=e.changedTouches[0].clientX-tx;
      if(Math.abs(dx)<50)return;
      var thumbs=Array.prototype.slice.call(document.querySelectorAll('.pc-thumb,.prod-thumb'));
      if(thumbs.length<2)return;
      var cur=Math.max(0,thumbs.findIndex(function(t){return t.classList.contains('is-active');}));
      var next=dx<0?Math.min(cur+1,thumbs.length-1):Math.max(cur-1,0);
      if(next===cur||next<0)return;
      thumbs[next].click();
      if(thumbs[next].scrollIntoView)thumbs[next].scrollIntoView({block:'nearest',inline:'nearest'});
    },{passive:true});
  })();


  /* ═══════════════════════════════════════════
     PRODUCT DESCRIPTION — collapse / read more
     ═══════════════════════════════════════════ */

  document.querySelectorAll('.product-desc[data-collapsible]').forEach(function(desc){
    var toggle=desc.nextElementSibling;
    if(!toggle||!toggle.classList.contains('desc-toggle'))return;
    desc.classList.add('is-collapsed');
    /* If the text fits within the collapsed height, no toggle needed */
    if(desc.scrollHeight<=desc.clientHeight+4){
      desc.classList.remove('is-collapsed');
      return;
    }
    toggle.hidden=false;
    toggle.addEventListener('click',function(){
      var collapsed=desc.classList.toggle('is-collapsed');
      toggle.textContent=collapsed?'Read more':'Read less';
      toggle.setAttribute('aria-expanded',collapsed?'false':'true');
    });
  });


  /* ═══════════════════════════════════════════
     CUSTOM FORM VALIDATION (custom order page)
     ═══════════════════════════════════════════ */

  var cfForm=document.getElementById('cf-form');
  if(cfForm&&cfForm.querySelector('.cf-acc')){
    var MAX_COLS=15, MAX_ROWS=11;
    var state={
      collection:null,collectionCustom:'',
      cards:null,layout:null,layoutCustom:'',gridPick:null,
      frame:null,frameCustom:'',
      email:''
    };
    var hidden={
      collection:document.getElementById('cf-collection'),
      cards:document.getElementById('cf-cards'),
      layout:document.getElementById('cf-layout'),
      frame:document.getElementById('cf-frame'),
      orderType:document.getElementById('cf-order-type')
    };
    var orderModal=document.getElementById('cf-order-modal');
    function isDirectEligible(){return state.collection==='Standard Cards'&&state.layout==='Standard grid'&&state.frame==='Standard black'}
    function showOrderModal(){
      if(!orderModal)return;
      orderModal.hidden=false;
      var first=orderModal.querySelector('[data-cf-order-now]');
      if(first)setTimeout(function(){first.focus()},50);
    }
    function hideOrderModal(){if(orderModal)orderModal.hidden=true}
    function setOrderType(val){if(hidden.orderType)hidden.orderType.value=val||''}
    var submitBtn=cfForm.querySelector('.cf-submit');
    var rows=cfForm.querySelectorAll('.cf-acc-row');
    function validEmail(v){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)}
    function getRow(step){return cfForm.querySelector('.cf-acc-row[data-step="'+step+'"]')}
    function setMeta(row,text){var m=row&&row.querySelector('[data-meta]');if(m)m.textContent=text||'—'}
    function markDone(step,done){var r=getRow(step);if(r)r.classList.toggle('is-done',!!done)}
    function openRow(step){
      rows.forEach(function(r){
        var isOpen=(+r.dataset.step===step);
        r.classList.toggle('is-open',isOpen);
        var head=r.querySelector('.cf-acc-head');
        if(head)head.setAttribute('aria-expanded',isOpen?'true':'false');
      });
    }
    function advance(cur){var nxt=getRow(cur+1);if(nxt)openRow(cur+1)}

    function updateCollectionHidden(){
      if(state.collection==='Other')hidden.collection.value=state.collectionCustom?'Other — '+state.collectionCustom:'Other — (unspecified)';
      else if(state.collection)hidden.collection.value=state.collection;
      else hidden.collection.value='';
    }
    function updateFrameHidden(){
      if(state.frame==='Custom')hidden.frame.value=state.frameCustom?'Custom — '+state.frameCustom:'Custom — (unspecified)';
      else if(state.frame)hidden.frame.value=state.frame;
      else hidden.frame.value='';
    }
    function updateLayoutHidden(){
      if(state.layout==='Standard grid'&&state.gridPick){
        hidden.layout.value='Standard grid ('+state.gridPick.c+'×'+state.gridPick.r+')';
      } else if(state.layout==='Custom'){
        hidden.layout.value=state.layoutCustom?'Custom — '+state.layoutCustom:'Custom — (unspecified)';
      } else {
        hidden.layout.value='';
      }
    }
    function updateCollectionMeta(){
      var row=getRow(1);
      if(!state.collection){setMeta(row,'Choose one');return}
      if(state.collection==='Other'){
        setMeta(row,state.collectionCustom?'Other — '+state.collectionCustom:'Other — specify');
      } else setMeta(row,state.collection);
    }
    function updateCardsMeta(){
      var parts=[];
      if(state.cards)parts.push(state.cards+' card'+(state.cards===1?'':'s'));
      if(state.layout==='Standard grid'&&state.gridPick)parts.push(state.gridPick.c+'×'+state.gridPick.r);
      else if(state.layout==='Standard grid')parts.push('standard grid');
      else if(state.layout==='Custom'&&state.layoutCustom)parts.push('custom — '+state.layoutCustom);
      else if(state.layout==='Custom')parts.push('custom layout');
      setMeta(getRow(2),parts.join(' · ')||'—');
    }
    function updateNotesMeta(){
      var notes=document.getElementById('cf-notes');
      var img=document.getElementById('cf-image-name');
      var bits=[];
      if(notes&&notes.value.trim())bits.push('Notes added');
      if(img&&img.value)bits.push('Image attached');
      setMeta(getRow(4),bits.length?bits.join(' · '):'Optional');
      markDone(4,bits.length>0);
    }
    function step1Complete(){return !!state.collection && (state.collection!=='Other'||state.collectionCustom)}
    function step2Complete(){
      if(!state.cards)return false;
      if(state.layout==='Standard grid')return !!state.gridPick;
      if(state.layout==='Custom')return !!state.layoutCustom;
      return false;
    }
    function step3Complete(){return !!state.frame && (state.frame!=='Custom'||state.frameCustom)}
    function step5Complete(){return validEmail(state.email)}
    function refreshSubmit(){
      var ok=step1Complete()&&step2Complete()&&step3Complete()&&step5Complete();
      if(submitBtn)submitBtn.disabled=!ok;
    }

    /* Grid computation + render */
    function computeGrids(n){
      var opts=[];
      for(var c=1;c<=MAX_COLS;c++){
        if(n%c!==0)continue;
        var r=n/c;
        if(r>=1&&r<=MAX_ROWS&&r===Math.floor(r))opts.push({c:c,r:r});
      }
      opts.sort(function(a,b){return Math.abs(a.c-a.r)-Math.abs(b.c-b.r)});
      return opts;
    }
    var gridHolder=document.getElementById('cf-grid-options');
    function renderGrids(){
      if(!gridHolder)return;
      gridHolder.innerHTML='';
      if(!state.cards){
        gridHolder.innerHTML='<p class="cf-help cf-no-grid">Enter a card count above first.</p>';
        return;
      }
      var opts=computeGrids(state.cards);
      if(!opts.length){
        gridHolder.innerHTML='<p class="cf-help cf-no-grid">No standard grid fits '+state.cards+' cards within our rails (max '+MAX_COLS+' columns, '+MAX_ROWS+' rows). Pick <b>Custom — Specify</b> instead.</p>';
        return;
      }
      opts.forEach(function(o){
        var b=document.createElement('button');
        b.type='button';
        b.className='cf-grid-opt';
        b.setAttribute('role','radio');
        b.dataset.cols=o.c;
        b.dataset.rows=o.r;
        b.textContent=o.c+' × '+o.r;
        if(state.gridPick&&state.gridPick.c===o.c&&state.gridPick.r===o.r){
          b.classList.add('is-selected');
          b.setAttribute('aria-checked','true');
        } else b.setAttribute('aria-checked','false');
        b.addEventListener('click',function(){
          state.gridPick={c:o.c,r:o.r};
          gridHolder.querySelectorAll('.cf-grid-opt').forEach(function(x){x.classList.remove('is-selected');x.setAttribute('aria-checked','false')});
          b.classList.add('is-selected');
          b.setAttribute('aria-checked','true');
          updateLayoutHidden();
          updateCardsMeta();
          markDone(2,step2Complete());
          refreshSubmit();
          advance(2);
        });
        gridHolder.appendChild(b);
      });
    }

    /* Tile radiogroups */
    rows.forEach(function(row){
      row.querySelectorAll('.cf-tile').forEach(function(tile){
        tile.addEventListener('click',function(){
          var group=tile.parentElement;
          group.querySelectorAll('.cf-tile').forEach(function(t){
            t.classList.remove('is-selected');
            t.setAttribute('aria-checked','false');
          });
          tile.classList.add('is-selected');
          tile.setAttribute('aria-checked','true');

          var step=+row.dataset.step;
          var value=tile.dataset.value;
          var reveal=tile.dataset.reveal;
          row.querySelectorAll('.cf-reveal').forEach(function(el){el.hidden=true});
          if(reveal){
            var rv=row.querySelector('#'+reveal);
            if(rv){rv.hidden=false;var inp=rv.querySelector('input');if(inp)setTimeout(function(){inp.focus()},100)}
          }
          if(step===1){
            state.collection=value;
            updateCollectionHidden();
            updateCollectionMeta();
            setOrderType('');
            if(value==='Other'){
              markDone(1,!!state.collectionCustom);
              if(state.collectionCustom)advance(1);
            } else {
              markDone(1,true);
              advance(1);
            }
          } else if(step===2){
            state.layout=value;
            state.gridPick=null;
            updateLayoutHidden();
            if(value==='Standard grid'){
              renderGrids();
              updateCardsMeta();
              markDone(2,false);
            } else if(value==='Custom'){
              updateCardsMeta();
              markDone(2,step2Complete());
              if(state.layoutCustom)advance(2);
            }
          } else if(step===3){
            state.frame=value;
            updateFrameHidden();
            setOrderType('');
            if(value==='Custom'){
              setMeta(row,state.frameCustom?'Custom — '+state.frameCustom:'Custom — specify');
              markDone(3,!!state.frameCustom);
            } else {
              setMeta(row,value);
              markDone(3,true);
              if(isDirectEligible())showOrderModal();
              else advance(3);
            }
          }
          refreshSubmit();
        });
      });
    });

    /* Card count input */
    var cardsInput=document.getElementById('cf-cards-input');
    if(cardsInput){
      cardsInput.addEventListener('input',function(){
        var v=parseInt(cardsInput.value,10);
        if(isNaN(v)||v<1){state.cards=null}
        else if(v>110){cardsInput.value=110;state.cards=110}
        else{state.cards=v}
        hidden.cards.value=state.cards||'';
        /* Invalidate grid pick if no longer matches count */
        if(state.gridPick&&(!state.cards||state.gridPick.c*state.gridPick.r!==state.cards))state.gridPick=null;
        if(state.layout==='Standard grid'){renderGrids();updateLayoutHidden()}
        updateCardsMeta();
        markDone(2,step2Complete());
        refreshSubmit();
      });
    }

    /* Custom collection description */
    var collectionCustomInput=document.getElementById('cf-collection-custom-input');
    if(collectionCustomInput){
      collectionCustomInput.addEventListener('input',function(){
        state.collectionCustom=collectionCustomInput.value.trim();
        updateCollectionHidden();
        updateCollectionMeta();
        if(state.collection==='Other')markDone(1,!!state.collectionCustom);
        refreshSubmit();
      });
    }

    /* Custom layout description */
    var layoutCustomInput=document.getElementById('cf-layout-custom-input');
    if(layoutCustomInput){
      layoutCustomInput.addEventListener('input',function(){
        state.layoutCustom=layoutCustomInput.value.trim();
        updateLayoutHidden();
        updateCardsMeta();
        if(state.layout==='Custom')markDone(2,step2Complete());
        refreshSubmit();
      });
    }

    /* Custom frame description */
    var frameCustomInput=document.getElementById('cf-frame-custom-input');
    if(frameCustomInput){
      frameCustomInput.addEventListener('input',function(){
        state.frameCustom=frameCustomInput.value.trim();
        updateFrameHidden();
        if(state.frame==='Custom'){
          setMeta(getRow(3),state.frameCustom?'Custom — '+state.frameCustom:'Custom — specify');
          markDone(3,!!state.frameCustom);
        }
        refreshSubmit();
      });
    }

    /* Notes + image affect meta of step 4 */
    var notesEl=document.getElementById('cf-notes');
    if(notesEl)notesEl.addEventListener('input',updateNotesMeta);
    var fileInput=document.getElementById('cf-image');
    if(fileInput)fileInput.addEventListener('change',function(){setTimeout(updateNotesMeta,80)});
    var rmBtn=document.getElementById('cf-upload-rm');
    if(rmBtn)rmBtn.addEventListener('click',function(){setTimeout(updateNotesMeta,80)});

    /* Email */
    var emailInput=document.getElementById('cf-email');
    if(emailInput){
      emailInput.addEventListener('input',function(){
        var v=emailInput.value.trim();
        state.email=v;
        if(validEmail(v)){setMeta(getRow(5),v);markDone(5,true)}
        else{setMeta(getRow(5),'—');markDone(5,false)}
        refreshSubmit();
      });
    }

    /* Next buttons */
    cfForm.querySelectorAll('[data-next]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var row=btn.closest('.cf-acc-row');
        var step=+row.dataset.step;
        var ok=true;
        if(step===1)ok=step1Complete();
        else if(step===2)ok=step2Complete();
        else if(step===3)ok=step3Complete();
        if(!ok){
          if(step===2&&!state.cards&&cardsInput)cardsInput.focus();
          return;
        }
        markDone(step,true);
        advance(step);
      });
    });

    /* Header toggles */
    cfForm.querySelectorAll('.cf-acc-head').forEach(function(head){
      head.addEventListener('click',function(e){
        e.preventDefault();
        var row=head.closest('.cf-acc-row');
        var step=+row.dataset.step;
        if(row.classList.contains('is-open')){
          row.classList.remove('is-open');
          head.setAttribute('aria-expanded','false');
        } else {
          openRow(step);
          row.scrollIntoView({behavior:'smooth',block:'nearest'});
        }
      });
    });

    /* Order modal buttons */
    if(orderModal){
      var btnOrderNow=orderModal.querySelector('[data-cf-order-now]');
      var btnAddDetails=orderModal.querySelector('[data-cf-add-details]');
      if(btnOrderNow)btnOrderNow.addEventListener('click',function(){
        var btn=this;
        if(btn.disabled)return;
        var original=btn.textContent;
        btn.disabled=true;
        btn.textContent='Adding…';
        fetch('/products/custom-trading-card-frame.js',{headers:{'Content-Type':'application/json'}})
          .then(function(r){if(!r.ok)throw new Error('product-not-found');return r.json()})
          .then(function(product){
            var match=null;
            for(var i=0;i<product.variants.length;i++){
              if(extractCount(product.variants[i].title)===state.cards){match=product.variants[i];break}
            }
            if(!match||!match.available)throw new Error('variant-unavailable');
            var props={};
            if(hidden.layout.value)props['Layout']=hidden.layout.value;
            return addToCart(match.id,1,props).then(function(){
              showToast('\u2713 '+product.title+' added to cart');
              hideOrderModal();
            });
          })
          .catch(function(err){
            btn.disabled=false;
            btn.textContent=original;
            showToast('Couldn\u2019t add to cart — we\u2019ll take it from here');
            setOrderType('Order Now (direct)');
            setMeta(getRow(4),'Skipped — order now');
            markDone(4,true);
            hideOrderModal();
            openRow(5);
          });
      });
      if(btnAddDetails)btnAddDetails.addEventListener('click',function(){
        setOrderType('Quote with additional details');
        hideOrderModal();
        openRow(4);
      });
      orderModal.querySelectorAll('[data-cf-modal-dismiss]').forEach(function(el){
        el.addEventListener('click',function(){
          setOrderType('Quote with additional details');
          hideOrderModal();
          openRow(4);
        });
      });
      document.addEventListener('keydown',function(e){
        if(e.key==='Escape'&&orderModal&&!orderModal.hidden){
          setOrderType('Quote with additional details');
          hideOrderModal();
          openRow(4);
        }
      });
    }

    /* Submit guard: if incomplete, open first bad step */
    cfForm.addEventListener('submit',function(e){
      refreshSubmit();
      if(submitBtn&&submitBtn.disabled){
        e.preventDefault();
        var checks=[[1,step1Complete],[2,step2Complete],[3,step3Complete],[5,step5Complete]];
        for(var i=0;i<checks.length;i++){
          if(!checks[i][1]()){openRow(checks[i][0]);break}
        }
      }
    });

    refreshSubmit();
  }


  /* ═══════════════════════════════════════════
     IMAGE UPLOAD (custom order page)
     ═══════════════════════════════════════════ */

  var cfUpload=document.getElementById('cf-upload');
  if(cfUpload){
    var cfImageInput=document.getElementById('cf-image'),
        cfUploadPh=document.getElementById('cf-upload-ph'),
        cfUploadPreview=document.getElementById('cf-upload-preview'),
        cfUploadThumb=document.getElementById('cf-upload-thumb'),
        cfUploadFile=document.getElementById('cf-upload-file'),
        cfUploadRm=document.getElementById('cf-upload-rm'),
        cfImageName=document.getElementById('cf-image-name'),
        cfImageUrl=document.getElementById('cf-image-url'),
        cfUploadStatus=document.getElementById('cf-upload-status'),
        cfCloudName=cfUpload.getAttribute('data-cloud-name'),
        cfUploadPreset=cfUpload.getAttribute('data-upload-preset'),
        cfUploading=false,
        cfSubmitPending=false;

    function setUploadStatus(msg,isError){
      if(!cfUploadStatus)return;
      cfUploadStatus.textContent=msg||'';
      cfUploadStatus.classList.toggle('is-error',!!isError);
    }

    function uploadToCloudinary(file){
      if(!cfCloudName||!cfUploadPreset){
        setUploadStatus("Image upload isn't set up yet — your request will still send without the image.",true);
        return;
      }
      cfUploading=true;
      if(cfImageUrl)cfImageUrl.value='';
      setUploadStatus('Uploading image…');
      var fd=new FormData();
      fd.append('file',file);
      fd.append('upload_preset',cfUploadPreset);
      fetch('https://api.cloudinary.com/v1_1/'+cfCloudName+'/auto/upload',{method:'POST',body:fd})
        .then(function(r){return r.json()})
        .then(function(data){
          cfUploading=false;
          if(data&&data.secure_url){
            if(cfImageUrl)cfImageUrl.value=data.secure_url;
            setUploadStatus('Image uploaded ✓');
          }else{
            setUploadStatus('Image upload failed — your request will still send without the image.',true);
          }
          if(cfSubmitPending){cfSubmitPending=false;cfForm&&(cfForm.requestSubmit?cfForm.requestSubmit():cfForm.submit())}
        })
        .catch(function(){
          cfUploading=false;
          setUploadStatus('Image upload failed — your request will still send without the image.',true);
          if(cfSubmitPending){cfSubmitPending=false;cfForm&&(cfForm.requestSubmit?cfForm.requestSubmit():cfForm.submit())}
        });
    }

    function showPreview(file){
      if(!file||!file.type.startsWith('image/'))return;
      var url=URL.createObjectURL(file);
      cfUploadThumb.src=url;
      cfUploadFile.textContent=file.name;
      cfUploadPh.style.display='none';
      cfUploadPreview.classList.add('show');
      cfImageInput.style.pointerEvents='none';
      if(cfImageName)cfImageName.value=file.name;
      uploadToCloudinary(file);
    }

    function clearPreview(){
      cfUploadPh.style.display='';
      cfUploadPreview.classList.remove('show');
      cfImageInput.style.pointerEvents='';
      cfImageInput.value='';
      if(cfUploadThumb.src){URL.revokeObjectURL(cfUploadThumb.src);cfUploadThumb.src=''}
      cfUploadFile.textContent='';
      if(cfImageName)cfImageName.value='';
      if(cfImageUrl)cfImageUrl.value='';
      cfUploading=false;
      setUploadStatus('');
    }

    cfImageInput.addEventListener('change',function(){
      if(cfImageInput.files&&cfImageInput.files[0])showPreview(cfImageInput.files[0]);
    });

    cfUploadRm.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      clearPreview();
    });

    /* Drag and drop */
    cfUpload.addEventListener('dragover',function(e){
      e.preventDefault();
      cfUpload.classList.add('dragover');
    });
    cfUpload.addEventListener('dragleave',function(){
      cfUpload.classList.remove('dragover');
    });
    cfUpload.addEventListener('drop',function(e){
      e.preventDefault();
      cfUpload.classList.remove('dragover');
      if(e.dataTransfer&&e.dataTransfer.files&&e.dataTransfer.files[0]){
        cfImageInput.files=e.dataTransfer.files;
        showPreview(e.dataTransfer.files[0]);
      }
    });

    if(cfForm){
      cfForm.addEventListener('submit',function(e){
        if(cfUploading){
          e.preventDefault();
          cfSubmitPending=true;
          setUploadStatus('Uploading image — sending as soon as it’s ready…');
        }
      });
    }
  }


  /* ═══════════════════════════════════════════
     NEWSLETTER (footer — enhanced client-side)
     ═══════════════════════════════════════════ */

  var nlForm=document.getElementById('nl-form');
  var nlMsg=document.getElementById('nl-msg');
  if(nlForm){
    nlForm.addEventListener('submit',function(e){
      var inp=nlForm.querySelector('.nl-input');
      if(!inp)return;
      if(!inp.value.trim()||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value.trim())){
        e.preventDefault();
        inp.style.borderColor='#ff6b6b';
        return;
      }
      /* Let Shopify customer form submit naturally if valid */
    });
  }


  /* ═══════════════════════════════════════════
     BACK TO TOP
     ═══════════════════════════════════════════ */

  var btt=document.getElementById('btt');
  if(btt){
    var bttTick=false;
    window.addEventListener('scroll',function(){
      if(!bttTick){
        bttTick=true;
        requestAnimationFrame(function(){
          btt.classList.toggle('show',window.scrollY>window.innerHeight*0.5);
          bttTick=false;
        });
      }
    },{passive:true});
    btt.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
  }


  /* ═══════════════════════════════════════════
     ESCAPE KEY — Close all modals/drawers
     ═══════════════════════════════════════════ */

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      if(cartDrawer&&cartDrawer.classList.contains('on')){closeCart();return}
      if(qo&&qo.classList.contains('on')){closeQo();return}
      if(fdPanel&&fdPanel.classList.contains('on')){
        /* closeFd is scoped inside the if block — call via class toggle */
        fdPanel.classList.remove('on');
        fdOv.classList.remove('on');
        if(fdTrap){fdTrap();fdTrap=null}
        if(fdLast)fdLast.focus();
        return;
      }
    }
  });


  /* ═══════════════════════════════════════════
     SHOWCASE SCROLL (anchor override)
     ═══════════════════════════════════════════ */

  document.querySelectorAll('a[href$="#sc-photos"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var el=document.getElementById('sc-photos');
      if(!el)return;
      e.preventDefault();
      var nav=document.querySelector('.nav');
      var offset=nav?nav.offsetHeight:0;
      window.scrollTo({top:el.getBoundingClientRect().top+window.pageYOffset-offset,behavior:'smooth'});
    });
  });


  /* ═══════════════════════════════════════════
     BLOG: COPY LINK
     ═══════════════════════════════════════════ */

  var copyBtn = document.getElementById('article-copy-link');
  if (copyBtn) {
    copyBtn.addEventListener('click', function() {
      var url = copyBtn.getAttribute('data-url');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function() {
          showToast('Link copied!');
        });
      } else {
        var tmp = document.createElement('input');
        tmp.value = url;
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        document.body.removeChild(tmp);
        showToast('Link copied!');
      }
    });
  }


  /* ═══════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════ */

  /* Update badge on page load */
  updateBadgeFromApi();

})();
